<template>
  <div id="footer" class="sections">

    <div class="section container light paddingBig">
      <div>
        <div class="item">
          <img src="@/assets/img/komatools-catalogue-book.jpg" :alt="$t('catalogue.alt')">
        </div>
        <div class="item">
          <div class="texts">
            <div class="text">
              {{ $t("catalogue.download") }}
              <h2><u>{{ $t("catalogue.pdf") }}</u></h2>
            </div>
            <div class="buttons wrap centered">
              <a :href="generateCatalogueUrl()" class="button accent" download>
                <div class="icon download"></div>
                <div class="text">{{ $t("catalogue.here") }}</div>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="section paddingBigger logo light">
      <div>
        <div class="logo"></div>
        <div class="motto" v-html="$t('footer.logoTitle')"></div>
      </div>
    </div>

    <div class="section paddingBigger linkGroups dark pro noPaddingBottom">
      <div>

        <div class="linkGroup grow">
          <div class="title">{{ $t("footer.whatAreYouLookingFor") }}</div>
          <div class="links">
            <LocalizedLink class="option" :to="$t('routes.power') + $t('filterRoutes.drillsAndScrewdrivers')">
              <div class="text">{{ $t("filtersArticles.drillsAndScrewdrivers.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.power') + $t('filterRoutes.sawsAndSanders')">
              <div class="text">{{ $t("filtersArticles.sawsAndSanders.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.power') + $t('filterRoutes.pressureWashers')">
              <div class="text">{{ $t("filtersArticles.pressureWashers.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.power') + $t('filterRoutes.bateriesAndCargers')">
              <div class="text">{{ $t("filtersArticles.bateriesAndCargers.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.handTools') + $t('filterRoutes.cuttingTools')">
              <div class="text">{{ $t("filtersArticles.cuttingTools.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.handTools') + $t('filterRoutes.measuringTools')">
              <div class="text">{{ $t("filtersArticles.measuringTools.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.handTools') + $t('filterRoutes.workshopEquipment')">
              <div class="text">{{ $t("filtersArticles.workshopEquipment.text") }}</div>
            </LocalizedLink>
          </div>
          <div class="links">
            <LocalizedLink class="option"
                           :to="$t('routes.accesorios') + $t('filterRoutes.flashlights')">
              <div class="text">{{ $t("filtersArticles.flashlights.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.accesorios') + $t('filterRoutes.drill')">
              <div class="text">{{ $t("filtersArticles.drill.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.accesorios') + $t('filterRoutes.spareParts')">
              <div class="text">{{ $t("filtersArticles.spareParts.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.chemicals') + $t('filterRoutes.adhesives')">
              <div class="text">{{ $t("filtersArticles.adhesives.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.chemicals') + $t('filterRoutes.paintsEnamelAndTreatments')">
              <div class="text">{{ $t("filtersArticles.paintsEnamelAndTreatments.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.chemicals') + $t('filterRoutes.lubricants')">
              <div class="text">{{ $t("filtersArticles.lubricants.text") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option"
                           :to="$t('routes.chemicals') + $t('filterRoutes.industrialCleaning')">
              <div class="text">{{ $t("filtersArticles.industrialCleaning.text") }}</div>
            </LocalizedLink>
          </div>
        </div>

        <div class="linkGroup grow">
          <div class="title">{{ $t("nav.products") }}</div>
          <div class="links">
            <LocalizedLink class="option" :to="$t('routes.bestSellers')">
              <div class="text">{{ $t("nav.bestSellers") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option" :to="$t('routes.novelties')">
              <div class="text">{{ $t("nav.novelties") }}</div>
            </LocalizedLink>
          </div>
        </div>

        <div class="linkGroup grow">
          <div class="title">{{ $t("nav.others") }}</div>
          <div class="links">
            <LocalizedLink class="option" :to="$t('routes.bateriesSystem12V')">
              <div class="text">{{ $t("nav.bateriesSystem12V") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option" :to="$t('routes.bateriesSystem20V')">
              <div class="text">{{ $t("nav.bateriesSystem20V") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option" :to="$t('routes.accesorios')">
              <div class="text">{{ $t("nav.accesorios") }}</div>
            </LocalizedLink>
            <LocalizedLink class="option" :to="$t('routes.dealers')">
              <div class="text">{{ $t("nav.dealers") }}</div>
            </LocalizedLink>
            <a :href="generateCatalogueUrl()" class="option" download>
              <div class="text">{{ $t("nav.pdfCatalogue") }}</div>
            </a>
          </div>
        </div>

      </div>
    </div>
    <div class="section disclaimers dark pro paddingBottom">
      <div>
        <div>&copy; KomaTools {{ new Date().getFullYear() }}</div>
        <div>{{ $t('footer.allRightsReserved') }}</div>
        <LocalizedLink class="option" :to="$t('routes.protectionData')">
          <div class="text">{{ $t("nav.protectionData") }}</div>
        </LocalizedLink>
      </div>
    </div>

  </div>
</template>

<script>
import LocalizedLink from "./LocalizedLink.vue"
import Tr from "@/translations"

export default {
  name: 'FooterComponent',
  components: {LocalizedLink},
  setup() {
    const generateCatalogueUrl = () => {

      let url = "/files/";

      if (Tr.currentLocale === 'pt') {
        url = url + "catalogo-koma-pt.pdf";
      } else {
        url = url + "catalogo-koma.pdf";
      }

      return url
    }

    return {generateCatalogueUrl}
  }
}

</script>